import { Route, Routes } from 'react-router-dom';
import TaxReturns from './TaxReturns';
import PreLodgementChecklist from './PreLodgementChecklist';
import ContainerWrapper from '@/pages/layout/ContainerWrapper';

export const TaxReturnsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<TaxReturns />} />
      {/* <Route path="application/:id?" element={<LodgeReturnApplication />} /> */}
      <Route
        path="pre-lodgement-checklist"
        element={<PreLodgementChecklist />}
      />
    </Routes>
  );
};
